import { useSitecoreContext as a, LayoutServicePageState as t } from "@sitecore-jss/sitecore-jss-react";
const i = () => {
  const { sitecoreContext: e } = a();
  return (e == null ? void 0 : e.pageEditing) && (e == null ? void 0 : e.pageState) === t.Edit;
};
export {
  i as u
};
